import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import AppSidebar from '../components/AppSidebar';
import FloatingHomeButton from '../components/FloatingHomeButton';

export default function MainLayout() {
    const location = useLocation();
    const isLauncher = location.pathname === '/';

    return (
        <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
            <Header />
            <div className="flex-1 flex overflow-hidden relative">
                {!isLauncher && <AppSidebar />}

                <main className="flex-1 overflow-y-auto relative">
                    {/* Floating button visible on all pages except launcher (or as requested 'all screens' - stick to !isLauncher for now to avoid redundancy on launcher) */}
                    {!isLauncher && <FloatingHomeButton />}

                    <Suspense fallback={<div className="flex justify-center p-10">Carregando...</div>}>
                        <Outlet />
                    </Suspense>
                </main>
            </div>
        </div>
    );
}
